import React from 'react'
import s from '../DishCard/styles.module.scss'

export const WarnBadge: React.FC = props => {
  return <span className={s.warnStock}>{props.children}</span>
}
